export default function About() {
  return (
    
    <div>
        <div className="container">
            <div className="content-wrapper">
                <section className="about-content">
                    <div className="about-text glass">
                        <h2>About Our Vision</h2>
                        <p>We believe in education and knowledge as a tool that can be used to better lives and address many of the problems we have in our society now-days. Our platform aims to play a crucial role in the provision of impactful knowledge on different areas of specialization in society. </p>
                        <p>Investment education is our top priority. When people have access to timely market information, they are in a better position to make informed decisions that can grow their returns in the long term. </p>
                        <p>We also strive to ensure we provide meaningful educational materials to students sitting for different professional examinations across the country. </p>
                        <p>Our publishing division is focused on publishing books on critical aspects of life in society that can empower readers to make the right decisions. </p>
                    </div>
                    <div className="stats">
                        <div className="stat-card glass">
                            <div className="stat-number">1500+</div>
                            <div className="stat-label">Daily Visitors</div>
                        </div>
                        <div className="stat-card glass">
                            <div className="stat-number">500+</div>
                            <div className="stat-label">Books Sold</div>
                        </div>
                        <div className="stat-card glass">
                            <div className="stat-number">2</div>
                            <div className="stat-label">Years Experience</div>
                        </div>
                        <div className="stat-card glass">
                            <div className="stat-number">24/7</div>
                            <div className="stat-label">Support Available</div>
                        </div>
                    </div>
                </section>

                
            </div>
        </div>
    </div>
  );
}
